import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fileUrl = (path) => (path ? `${API}/files/${path}` : null);

export const recipeImage = (recipe) => {
  if (recipe?.images && recipe.images.length > 0) return fileUrl(recipe.images[0]);
  return null;
};
